module.exports = __webpack_public_path__ + "assets/media/l-1.ee288396.svg";